import { useState } from "react";
import { trpc } from "../../../lib/api/trpc";
import { logError } from "../../../utils/errors/errorHandler";

interface CancelEmailChangeResult {
  success: boolean;
  error?: string;
}

export const useCancelEmailChange = () => {
  const [isLoading, setIsLoading] = useState(false);

  // @ts-ignore - Type checking for trpc.user property
  const mutation = trpc.user.cancelEmailChange.useMutation();

  const cancelEmailChange = async (
    userId: string,
  ): Promise<CancelEmailChangeResult> => {
    setIsLoading(true);

    try {
      // @ts-ignore - Type checking for trpc mutation
      await mutation.mutateAsync({ id: userId });

      return { success: true };
    } catch (error: any) {
      logError(error, "Cancel Email Change");
      return {
        success: false,
        error: error?.message || "Failed to cancel email change",
      };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cancelEmailChange,
    isLoading,
  };
};
